import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import moment from 'moment/moment';
import { GenericHttpService } from 'src/app/services/generic-http.service';
import { OrderService } from 'src/app/services/order.service';
import { StorageService } from 'src/app/services/storage.service';
import { ExportExcelService } from 'src/app/services/export-excel.service';
import { MessageService } from 'primeng/api';
import { StoreOptionsService } from './store-options.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { TabItem } from 'src/app/shared-components/app-tab-view/app-tab-view.component';
import { AnalyticsService } from 'src/app/services/analytics.service';

interface City {
  label: string;
  value: string;
}

@Component({
  selector: 'app-orders-listing',
  templateUrl: './orders-listing.component.html',
  styleUrls: ['./orders-listing.component.scss'],
  standalone: false,
})
export class OrdersListingComponent implements OnInit, OnDestroy {
  @ViewChild('calendar') calendar: any;
  @ViewChild('viewOrderData') viewOrderData: TemplateRef<any>;

  rangeDates: any;
  selectedCity!: City;
  searchText: string = '';
  bulkSearchText: string = '';
  searchOrderId: any = '';
  searchBulkOrderId: any = '';
  viewOrderId: any = '';
  headerData: any = [];
  rowData: any = [];
  maxDate: Date = new Date();
  tableRows: any = [];
  valueDate: any = [];
  isViewMoreClicked: boolean = false;
  bulkOrderOption: any;
  orderFilters: any;
  orderOption: any = {
    searchText: '',
    serviceType: '',
    orderStatus: '',
    tabIndex: 0,
    branch_ids: [],
  };
  DATE_FORMAT = 'YYYY-MM-DD';
  onSearchTextChange: Subject<string> = new Subject<string>();
  onBulkSearchTextChange: Subject<string> = new Subject<string>();
  onOrderIdChange: Subject<string> = new Subject<string>();
  onOrderIndividualIdChange: Subject<string> = new Subject<string>();
  onBulkSingleId: Subject<string> = new Subject<string>();
  onBulkOrderIdChange: Subject<string> = new Subject<string>();
  branches: any;
  selectedBranch: any;
  selectedService: any;
  selectedstatus: any;
  selectedBulkStatus: any;
  fieldsToDisplay: any = [
    'user_name',
    'order_status',
    'user_email',
    'branch',
    'state',
    'order_type',
    'account',
    'total_stamps',
    'first_party_name',
    'second_party_name',
    'stamp_duty_paid_by',
    'stamp_duty_amount',
    'total_stamps_amount',
    'execution_date',
    'certificate_number',
    'referance_number',
    'issued_date',
    'denomination',
    'cess_amount',
    'email',
    'sign_method',
    'status',
    'sign_url',
    'signed_at',
  ];
  estampFilters = { estamp_fields: [] };
  setStateId: any;
  bulkOrderId: any;
  branchName: string;
  exportBtn: boolean = true;
  userRole: string;
  searchIndividualOrderId: string;
  branchFilter = {
    search: '',
  };
  onBranchSearchTextChange: Subject<string> = new Subject<string>();
  urlQuery: any;
  isShowAutoBulkOption: boolean = false;
  account_id: string;
  private destroy$ = new Subject<void>();

  ordersTabs: TabItem[] = [
    { label: 'Individual', icon: 'pi pi-user' },
    { label: 'Bulk', icon: 'pi pi-copy' },
  ];

  private updateOrdersTabs(): void {
    const tabs: TabItem[] = [
      { label: 'Individual', icon: 'pi pi-user' },
      { label: 'Bulk', icon: 'pi pi-copy' },
    ];
    if (this.isShowAutoBulkOption) {
      tabs.push({ label: 'Automated Bulk Upload', icon: 'pi pi-upload' });
    }
    this.ordersTabs = tabs;
  }
  bulk_estamp_order_status = [
    { name: 'In Progress', code: 'IN_PROGRESS' },
    { name: 'Completed', code: 'COMPLETED' },
    { name: 'Initiated', code: 'INITIATED' },
    { name: 'Waiting for approval', code: 'AWAITING_APPROVAL' },
    { name: 'Rejected', code: 'REJECTED' },
    { name: 'Failed', code: 'FAILED' },
  ];
  constructor(
    private cookieService: CookieService,
    private router: Router,
    private exportExcelService: ExportExcelService,
    private modalService: NgbModal,
    private orderService: OrderService,
    private genericHttpService: GenericHttpService,
    private messageService: MessageService,
    private storageService: StorageService,
    private activatedRoute: ActivatedRoute,
    private storeOptionsService: StoreOptionsService,
    private route: ActivatedRoute,
    private userService: UserProfileService,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService
  ) {
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((queryParams) => {
        if (queryParams['tabIndex'] === '2') {
          this.urlQuery = queryParams;
          return;
        }

        this.orderOption.tabIndex = queryParams['isBulk'] === 'true' ? 1 : 0;
        if (Object.keys(queryParams).length > 0) {
          this.urlQuery = queryParams;
          this.selectedService = this.orderOption['serviceType'] =
            queryParams?.serviceType;

          const rawStatus = queryParams?.orderStatus;
          const statusArray =
            rawStatus && rawStatus !== 'null' && rawStatus !== ''
              ? Array.isArray(rawStatus)
                ? rawStatus
                : [rawStatus]
              : [];

          this.selectedstatus = statusArray;
          this.orderOption['orderStatus'] = statusArray;
          this.selectedBulkStatus = statusArray;
          this.orderOption['bulkOrderStatus'] = statusArray;
          this.branchName = queryParams?.branch;

          if (queryParams?.isBulk) {
            if (queryParams?.isBulk === 'true') {
              this.bulkOrderId = queryParams?.id;
              this.orderOption.tabIndex = 1;
            } else {
              this.orderOption.tabIndex = 0;
            }
          } else if (queryParams?.bulkOrderid) {
            this.bulkOrderId = queryParams?.bulkOrderid;
            this.orderOption.tabIndex = 1;
          } else {
            this.orderOption.tabIndex = 0;
          }
        }
      });

    this.orderService.getBranchList().subscribe((res: any) => {
      this.branches = res['content'];
      this.branches = this.branches.filter(
        (element) => element.is_active === true,
      );
    });

    this.onSearchTextChange
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.orderOption['searchText'] = value;
        this.orderOption = Object.assign({}, this.orderOption);
      });

    this.onBulkSearchTextChange
      .pipe(debounceTime(1500), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.orderOption['searchText'] = value;
        this.orderOption = Object.assign({}, this.orderOption);
      });

    this.onOrderIdChange
      .pipe(debounceTime(1500), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.orderOption['order_ids'] = value;
        this.orderOption = Object.assign({}, this.orderOption);
      });
    this.onOrderIndividualIdChange
      .pipe(debounceTime(1500), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.viewOrder(value);
      });

    this.onBulkSingleId
      .pipe(debounceTime(1500), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.orderOption['bulkSingle_ids'] = value;
        this.orderOption = Object.assign({}, this.orderOption);
      });

    this.onBulkOrderIdChange
      .pipe(debounceTime(1500), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.orderOption['bulk_order_id'] = value;
        this.orderOption = Object.assign({}, this.orderOption);
      });

    this.onBranchSearchTextChange
      .pipe(debounceTime(1500), takeUntil(this.destroy$))
      .subscribe((value) => {
        this.orderService
          .getBranchListWithSearch(value)
          .subscribe((res: any) => {
            this.branches = res['content'];
            this.branches = this.branches.filter(
              (element) => element.is_active === true,
            );
          });
      });

    this.userRole = this.storageService.getRole() || null;
    this.account_id = this.storageService.getAccountId() || null;

    this.userService.getOrderReviewConsent(this.account_id).subscribe((res) => {
      this.isShowAutoBulkOption =
        res['content']?.additional_configuration?.bulk_catupload
          ?.bulk_catupload_enabled === true;

      this.updateOrdersTabs();
      this.cdr.detectChanges();

      if (this.urlQuery?.tabIndex === '2' && this.isShowAutoBulkOption) {
        setTimeout(() => {
          this.orderOption = Object.assign({}, this.orderOption, {
            tabIndex: 2,
          });
          this.cdr.detectChanges();
        }, 0);
      }
    });
  }

  ngOnInit() {
    this.getFilters();
    if (this.urlQuery?.tabIndex !== '2') {
      if (this.orderService.orderType != undefined)
        this.orderService.orderType === 'Individual'
          ? (this.orderOption.tabIndex = 0)
          : (this.orderOption.tabIndex = 1);
    }

    if (this.selectedstatus) {
      this.orderOption['orderStatus'] = this.selectedstatus;
    }
    if (this.selectedBranch) {
      this.orderOption.branch_ids.push(this.selectedBranch.id);
    }
    if (this.selectedService) {
      this.orderOption['serviceType'] = this.selectedService;
    }
    if (this.rangeDates) {
      this.onSelect();
    }
    if (this.searchText) {
      this.onChangeSearchText(this.searchText);
    }
    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams['bulkOrderid']) {
        this.orderOption.tabIndex = 1;
      }
    });
  }

  getFilters() {
    var params = { filters: 'order_type, order_status, bulk_status' };
    this.genericHttpService.getFilters(params).subscribe((resp) => {
      if (resp.status == 200) {
        this.orderFilters = resp.content;

        this.orderFilters.order_status.forEach((element) => {
          if (element.code === 'WAITING_FOR_APPROVAL') {
            element.name = 'Approval Pending';
          }
        });
        this.orderFilters.bulk_status.forEach((element) => {
          if (element.code === 'WAITING_FOR_APPROVAL') {
            element.name = 'Approval Pending';
          }
        });
        this.addPaymentSuccessfulFilter(this.orderFilters.order_status);

        // Re-bind status filter now that options are loaded so p-multiSelect
        // can resolve the code strings coming from query params.
        if (this.urlQuery?.orderStatus) {
          const raw = this.urlQuery.orderStatus;
          const statusArray =
            raw && raw !== 'null' && raw !== ''
              ? Array.isArray(raw)
                ? raw
                : [raw]
              : [];
          this.selectedstatus = [...statusArray];
          this.orderOption['orderStatus'] = statusArray;
          this.selectedBulkStatus = [...statusArray];
          this.orderOption['bulkOrderStatus'] = statusArray;
        }

        this.cdr.detectChanges();
      }
    });
  }

  private addPaymentSuccessfulFilter(options: { name: string; code: string }[]): void {
    if (!options.some((option) => option.code === 'PAYMENT_SUCCESSFUL')) {
      options.push({ name: 'Payment Successful', code: 'PAYMENT_SUCCESSFUL' });
    }
  }

  onChangeSearchText(value) {
    this.onSearchTextChange.next(value);
    this.storeOptionsService.searchText = this.searchText;
  }

  onSearchTextPaste(_event: ClipboardEvent) {
    setTimeout(() => {
      this.orderOption['searchText'] = this.searchText;
      this.orderOption = Object.assign({}, this.orderOption);
    }, 0);
  }

  onSearchTextEnter() {
    this.orderOption['searchText'] = this.searchText;
    this.orderOption = Object.assign({}, this.orderOption);
  }

  onChangeBulkSearchText(value) {
    if (value) {
      this.onBulkSearchTextChange.next(value);
      this.storeOptionsService.bulkSearchText = this.bulkSearchText;
      544;
    } else {
      this.onBulkSearchTextChange.next('');
      this.storeOptionsService.bulkSearchText = this.bulkSearchText;
    }
  }

  onSearchOrderId(event) {
    this.onOrderIdChange.next(event);
    //  this.storeOptionsService.orderId = this.searchOrderId;
  }

  onSearchIndividualOrderId(event) {
    if (event) {
      this.orderOption['searchOrderId'] = event;
      this.orderOption = Object.assign({}, this.orderOption); // Trigger ngOnChanges
    } else {
      delete this.orderOption['searchOrderId'];
      this.orderOption = Object.assign({}, this.orderOption); // Trigger ngOnChanges
    }
  }

  viewSearchOrderId(event) {
    this.onBulkSingleId.next(event);
  }

  onSearchBulkOrderId(event) {
    this.onBulkOrderIdChange.next(event);
    this.storeOptionsService.bulkOrderId = this.searchBulkOrderId;
  }

  onServiceTypeChange(event) {
    this.orderOption['serviceType'] = event.value;
    this.orderOption = Object.assign({}, this.orderOption);
    this.storeOptionsService.selectedService = this.selectedService;
  }

  onStateChanage(event) {
    this.orderOption.branch_ids = [];
    if (event.value !== null) this.orderOption.branch_ids.push(event.value.id);
    this.orderOption = Object.assign({}, this.orderOption);
    this.storeOptionsService.selectedBranch = this.selectedBranch;
  }

  onOrderStatusChange(event) {
    const selectedStatuses = Array.isArray(event.value)
      ? event.value
      : event.value
        ? [event.value]
        : [];
    this.selectedstatus = selectedStatuses;
    this.orderOption['orderStatus'] = this.selectedstatus;
    this.orderOption = Object.assign({}, this.orderOption);
    this.storeOptionsService.selectedStatus = this.selectedstatus;
  }

  onBulkOrderStatusChange(event) {
    this.orderOption['bulkOrderStatus'] = event.value;
    this.orderOption = Object.assign({}, this.orderOption);
    this.storeOptionsService.selectedBulkStatus = this.selectedBulkStatus;
  }
  onBulkEstampOrderStatusChange(event) {
    this.orderOption['bulkEstampOrderStatus'] = event.value;
    this.orderOption = Object.assign({}, this.orderOption);
    this.storeOptionsService.selectedBulkStatus = this.selectedBulkStatus;
  }

  getAllDetails(event) {
    this.orderOption['orderStatus'] = null;
    this.orderOption['bulkOrderStatus'] = null;
    this.orderOption['bulkEstampOrderStatus'] = null;
    this.orderOption = Object.assign({}, this.orderOption);
  }

  onbulkOrderOptionChange(event: any) {
    this.isViewMoreClicked = event;
    this.orderOption['isViewMoreClicked'] = event;
    if (!this.isViewMoreClicked) {
      this.viewOrderId = '';
      delete this.orderOption['bulkSingle_ids'];
      this.bulkSearchText = '';
      this.onBulkSearchTextChange.next('');
      this.storeOptionsService.bulkSearchText = this.bulkSearchText;
    }
  }

  onorderOptionChange(event: any) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.cookieService.set('isBulkData', 'false');
    this.orderService.orderType = 'Individual';
  }

  onChangeTab(evt: any) {
    this.bulkSearchText = '';
    this.searchIndividualOrderId = '';
    this.searchOrderId = '';
    this.searchText = '';
    this.searchBulkOrderId = '';
    this.selectedBulkStatus = '';
    this.rangeDates = [];
    this.selectedBranch = '';
    this.selectedstatus = '';
    this.selectedService = '';
    this.urlQuery = null;
    
    const clickedLabel = this.ordersTabs[evt.index]?.label;
    
    if (clickedLabel) {
      this.analyticsService.trackEvent('click_order_tab', {
        tab_label: clickedLabel 
      });
    }

    if (evt.index === 0) {
      this.exportBtn = true;
      this.isViewMoreClicked = false;
      this.router.navigate(['doqfy/orders/orders-list']);
    } else if (evt.index === 1) {
      this.exportBtn = false;
    }

    this.orderOption = {
      searchText: '',
      serviceType: '',
      orderStatus: '',
      tabIndex: evt.index,
      branch_ids: '',
      isViewMoreClicked: false,
      bulkEstampOrderStatus: '',
    };
  }

  onViewMore() {
    this.isViewMoreClicked = true;
  }
  savePersonalDetails() {}

  back() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  onSelect() {
    if (this.rangeDates[1]) {
      if (this.calendar) {
        this.calendar.overlayVisible = false;
      }

      this.orderOption['startDate'] = moment(this.rangeDates[0]).format(
        this.DATE_FORMAT,
      );
      this.orderOption['endDate'] = moment(this.rangeDates[1]).format(
        this.DATE_FORMAT,
      );
      this.orderOption = Object.assign({}, this.orderOption);
      this.storeOptionsService.rangeDates = this.rangeDates;
    }
  }

  onDateRangeChange(evt) {
    if (evt === null) {
      delete this.orderOption['startDate'];
      delete this.orderOption['endDate'];
      this.orderOption = Object.assign({}, this.orderOption);
    }
  }

  formatDateWithTime(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  export() {
    if (this.orderOption.branch_ids != '') {
      this.estampFilters['branch_id'] = this.orderOption.branch_ids;
      this.estampFilters['state_id'] = this.setStateId;
    }
    if (this.orderOption.serviceType != '') {
      this.estampFilters['order_type'] = this.orderOption.serviceType;
    }
    if (this.orderOption.startDate != '') {
      this.estampFilters['start_date'] = this.orderOption.startDate;
      this.estampFilters['end_date'] = this.orderOption.endDate;
    }
    if (this.orderOption.orderStatus != '') {
      this.estampFilters['order_status'] = this.orderOption.orderStatus;
    }
    this.estampFilters['estamp_fields'] = this.fieldsToDisplay;

    const today = new Date();
    const formattedDate = this.formatDateWithTime(today);

    let fileName = 'Consumptio Report' + '_' + formattedDate;

    this.exportExcelService
      .getOrderConsumption(this.estampFilters)
      .subscribe((res) => {
        if (res.status === 200 && res['message'] != 'No records found') {
          this.messageService.add({
            severity: 'success',
            summary: res.message,
            icon: 'pi-check-circle',
          });
        } else {
          this.messageService.add({ severity: 'warn', summary: res.message });
        }
      });
  }

  onBranchClear(): void {
    this.selectedBranch = null;
    this.orderOption.branch_ids = [];
    this.orderOption = Object.assign({}, this.orderOption);
    this.storeOptionsService.selectedBranch = null;
  }

  onServiceTypeClear(): void {
    this.selectedService = null;
    this.orderOption['serviceType'] = null;
    this.orderOption = Object.assign({}, this.orderOption);
    this.storeOptionsService.selectedService = null;
  }

  onBranchFilter(evt) {
    if (evt.filter === null) {
      this.branchFilter.search = '';
      this.onBranchSearchTextChange.next('');
    } else this.onBranchSearchTextChange.next(evt.filter);
  }

  onKeyPress(event: KeyboardEvent) {
    // Allow only numbers and space character
    if (
      !(event.charCode >= 48 && event.charCode <= 57) &&
      event.charCode !== 32
    ) {
      event.preventDefault();
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text/plain');
    const onlyNumbers = pastedText.replace(/[^\d ]/g, ''); // Remove non-numeric characters except space
    document.execCommand('insertText', false, onlyNumbers);
  }

  viewOrder(id) {
    this.viewOrderId = { orderId: id, bulkOrderid: null };
    this.modalService
      .open(this.viewOrderData, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        },
      );
  }
  closeView() {
    this.modalService.dismissAll();
  }
  onAutomatedBulkOrderOptionChange(event: any) {
    this.isViewMoreClicked = event;
    this.orderOption['isViewMoreClicked'] = event;
    if (!this.isViewMoreClicked) {
      this.viewOrderId = '';
      delete this.orderOption['bulkSingle_ids'];
      this.bulkSearchText = '';
      this.onBulkSearchTextChange.next('');
      this.storeOptionsService.bulkSearchText = this.bulkSearchText;
    }
  }

}
